module.exports = __webpack_public_path__ + "static/img/new-master-platform@m.cd802db.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/new-master-platform@m.jpg
// module id = h1YF
// module chunks = 0